import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound, UserCheck } from "lucide-react";

// Retrait du colis : code de retrait (visible quand « Disponible »), personne autorisée, frais de stockage
export const PickupBox = ({ s }) => {
  const { t } = useI18n();
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", phone: "", id_number: "" });
  const load = () => api.get(`/shipments/${s.id}/pickup-info`).then(({ data }) => setInfo(data)).catch(() => {});
  useEffect(() => { load(); }, [s.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (s.status === "delivered" || !info) return null;
  const save = async () => {
    if (!f.name.trim()) { toast.error(t("pu.name")); return; }
    try {
      await api.put(`/shipments/${s.id}/pickup-person`, f);
      toast.success(t("pu.saved")); setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  return (
    <div className="mt-3 border border-border bg-secondary/40 p-3 text-sm" data-testid={`pickup-box-${s.reference}`}>
      {s.status === "available" && info.pickup_code && (
        <div className="flex items-center gap-2" data-testid={`pickup-code-${s.reference}`}>
          <KeyRound className="h-4 w-4 text-accent" />
          <span>{t("pu.code")} : <b className="font-mono text-base tracking-widest text-accent">{info.pickup_code}</b></span>
          <span className="text-xs text-muted-foreground">— {t("pu.codeHint")}</span>
        </div>
      )}
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <UserCheck className="h-4 w-4 text-muted-foreground" />
        {info.pickup_person
          ? <span data-testid={`pickup-person-${s.reference}`}>{t("pu.person")} : <b>{info.pickup_person.name}</b>{info.pickup_person.phone && <> · {info.pickup_person.phone}</>}</span>
          : <span className="text-muted-foreground">{t("pu.nobody")}</span>}
        <Button size="sm" variant="outline" className="rounded-sm h-7" data-testid={`pickup-set-person-${s.reference}`}
          onClick={() => { setF({ name: info.pickup_person?.name || "", phone: info.pickup_person?.phone || "", id_number: info.pickup_person?.id_number || "" }); setOpen(true); }}>
          {info.pickup_person ? t("pu.edit") : t("pu.setPerson")}
        </Button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="pickup-person-dialog">
          <DialogHeader><DialogTitle>{t("pu.setPerson")} — {s.reference}</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">{t("pu.hint")}</p>
          <div className="grid gap-3">
            <div><Label>{t("pu.name")} *</Label><Input data-testid="pickup-name" className="rounded-sm" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></div>
            <div><Label>{t("pu.phone")}</Label><Input data-testid="pickup-phone" className="rounded-sm" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} /></div>
            <div><Label>{t("pu.idnum")}</Label><Input data-testid="pickup-idnum" className="rounded-sm" value={f.id_number} onChange={(e) => setF({ ...f, id_number: e.target.value })} /></div>
          </div>
          <DialogFooter><Button data-testid="pickup-person-save" className="rounded-sm bg-accent text-white" onClick={save}>{t("pu.save")}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
